export default "__VITE_ASSET__wm1s9V8b__"